export interface Item {
  /**
   * Item ID
   */
  id: string;

  /**
   * Item name.
   */
  name?: string | null;

  /**
   * Item description.
   */
  description?: string | null;

  /**
   * Item image.
   */
  image?: { url?: string | null };

  /**
   * Additional information about the item. For example, an item's price.
   */
  note?: string | null;

  /**
   * Additional fields associated with an item. The content of this object might changes based on the Wix service defined in the `tag` field.
   */
  additionalFields?: Record<string, any> | null;
}

export interface ItemSelectionOptions {
  /**
   * The provider key, which is typically a combination of the appId and the key set in the dev-center config `appId_key`
   */
  providerKey: string;

  /**
   * The maximum number of items that can be selected in the modal. Default is 1 when not set.
   */
  maxSelected?: number;

  /**
   * An optional custom text for the primary action button in the modal, providing the ability to override the default content defined by the provider.
   */
  primaryButtonText?: string;

  /**
   * An optional custom title for the modal, allowing the override of the default content provided by the provider.
   */
  title?: string;

  /**
   * Initial selection items IDs. The items will be selected when the modal is opened.
   */
  initialSelect?: string[];
}

export interface ItemSelectionResult {
  items: Item[];
}

export type ItemSelection = (
  providerKey: ItemSelectionOptions['providerKey'],
  request?: Omit<ItemSelectionOptions, 'providerKey'>,
) => Promise<ItemSelectionResult>;

